/* Swipe to unlock on the calculator plan card (27 Oct 2026).
   Adds a slider after the email field. Dragging the handle across (or pressing Enter or
   Space on it) submits the SAME form through the real submit button, so every existing
   path still runs: validation, the 'submit' listener in unc-bt-outcome.js, Shopify's
   captcha, the in-place send. If this script never runs, the normal button stays.
   - Names/emails not filled in: the browser shows its own message and the handle springs back.
   - The real button is hidden, not removed (Enter inside a field still submits).
   To retire: remove the script + stylesheet lines in layout/theme.liquid (calc block). */
(function () {
  'use strict';
  var reduced = false;
  try { reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  var LABEL = 'Swipe to unlock';
  var BUSY = 'Unlocking…';
  var DONE_AT = 0.85;

  function lockSvg() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path class="unc-swipe__shackle" d="M8 11V8a4 4 0 0 1 8 0v3" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>' +
      '<rect x="5" y="11" width="14" height="10" rx="2.5" fill="currentColor"/></svg>';
  }

  function init(fields) {
    if (fields.dataset.swipeReady) return;
    var form = fields.closest('form');
    var real = fields.querySelector('[data-bto-submit]');
    if (!form || !real) return;
    fields.dataset.swipeReady = '1';

    var label = fields.dataset.swipeLabel || LABEL;
    var track = document.createElement('div');
    track.className = 'unc-swipe';
    track.innerHTML =
      '<span class="unc-swipe__fill"></span>' +
      '<span class="unc-swipe__label" aria-live="polite"></span>' +
      '<button type="button" class="unc-swipe__handle" aria-label="' + label + '. Press Enter to unlock.">' + lockSvg() + '</button>';
    var fill = track.querySelector('.unc-swipe__fill');
    var text = track.querySelector('.unc-swipe__label');
    var handle = track.querySelector('.unc-swipe__handle');
    text.textContent = label;

    real.setAttribute('tabindex', '-1');
    fields.classList.add('unc-swipe-on');
    real.parentNode.insertBefore(track, real.nextSibling);

    var p = 0, travel = 0, startX = 0, startP = 0, dragging = false, moved = false, state = 'idle', resetTimer = 0, armed = false;

    function measure() {
      travel = Math.max(0, track.clientWidth - handle.offsetWidth - 8);
    }

    function paint(v) {
      p = Math.max(0, Math.min(1, v));
      var x = p * travel;
      handle.style.transform = 'translateX(' + x + 'px)';
      fill.style.width = (x + handle.offsetWidth + 4) + 'px';
      text.style.opacity = String(Math.max(0, 1 - p * 1.6));
    }

    function settle(to, cb) {
      track.classList.add('is-settling');
      if (to === 0) { track.classList.remove('is-armed'); armed = false; }
      paint(to);
      setTimeout(function () { track.classList.remove('is-settling'); if (cb) cb(); }, reduced ? 0 : 380);
    }

    function buzz(ms) {
      try { if (navigator.vibrate) navigator.vibrate(ms); } catch (e) {}
    }

    function reset() {
      clearTimeout(resetTimer);
      state = 'idle';
      track.classList.remove('is-done', 'is-armed');
      text.textContent = label;
      text.style.opacity = '';
      armed = false;
      handle.disabled = false;
      settle(0);
    }

    function complete() {
      if (state !== 'idle') return;
      measure();
      // Missing or invalid name/email: let the browser say so, spring back.
      if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
        settle(0);
        try { form.reportValidity(); } catch (e) {}
        return;
      }
      state = 'sending';
      settle(1);
      track.classList.add('is-done');
      text.textContent = BUSY;
      text.style.opacity = '1';
      handle.disabled = true;
      buzz([14, 40, 22]);
      // Back to a usable slider if nothing happened (captcha dismissed, offline).
      resetTimer = setTimeout(reset, 14000);
      try {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(real);
        else real.click();
      } catch (e) {
        real.click();
      }
    }

    handle.addEventListener('pointerdown', function (e) {
      if (state !== 'idle') return;
      measure();
      dragging = true; moved = false; armed = false;
      startX = e.clientX; startP = p;
      track.classList.remove('is-settling');
      try { handle.setPointerCapture(e.pointerId); } catch (err) {}
    });
    handle.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      paint(startP + dx / (travel || 1));
      var nowArmed = p >= DONE_AT;
      if (nowArmed && !armed) buzz(8);
      armed = nowArmed;
      track.classList.toggle('is-armed', armed);
    });
    function end() {
      if (!dragging) return;
      dragging = false;
      if (!moved) {
        // a plain tap: show how it works
        track.classList.remove('is-nudge');
        void track.offsetWidth;
        track.classList.add('is-nudge');
        setTimeout(function () { track.classList.remove('is-nudge'); }, 650);
        return;
      }
      if (p >= DONE_AT) complete();
      else settle(0);
    }
    handle.addEventListener('pointerup', end);
    handle.addEventListener('pointercancel', function () { dragging = false; settle(0); });
    handle.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowRight') {
        e.preventDefault();
        complete();
      }
    });

    // The existing script disables the real button while sending and re-enables it if the
    // send fails and falls back; follow that so the slider never gets stuck.
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        if (state === 'sending' && !real.disabled && !real.hasAttribute('aria-busy')) {
          clearTimeout(resetTimer);
          resetTimer = setTimeout(reset, 900);
        }
      }).observe(real, { attributes: true, attributeFilter: ['disabled', 'aria-busy'] });
    }

    window.addEventListener('resize', function () { measure(); if (state === 'idle') paint(p); });
    measure();
    // The card is hidden until the first drink: measure again once it is shown.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { if (en[0].isIntersecting) { measure(); if (state === 'idle') paint(p); } }).observe(track);
    }
  }

  function scan() {
    var list = document.querySelectorAll('.unc-bt__ask-fields');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();
